import { ThemeMode } from '../enums';

export const THEMES: Record<ThemeMode, string> = {
  [ThemeMode.LIGHT]: ThemeMode.LIGHT.toString(),
  [ThemeMode.DARK]: ThemeMode.DARK.toString(),
};
